<script setup lang="ts">
import type { Attr } from "~/types";

const props = withDefaults(
  defineProps<{
    attr_nums?: number[];
    size?: number;
    spaceBetween?: number;
  }>(),
  {
    size: 16,
    spaceBetween: 16,
  },
);

const attrs = inject<Attr[]>("attrs", []);

// タグとして表示対象のattr_numsからattrのリストをattrsで生成する
const showAttrs = computed(() => {
  return props.attr_nums?.map((attr_num) => {
    return attrs.find((o: any) => o.attr_num == attr_num);
  });
});
</script>

<template>
  <div class="flex flex-wrap" :style="{ gap: spaceBetween + 'px' }">
    <SekouAttrLink
      v-for="attr in showAttrs"
      :disableCount="true"
      :attr="attr"
      @click.prevent=""
      class="line-clamp-1"
      :style="{ fontSize: size + 'px' }"
    />
  </div>
</template>
